{
  "OrganizationTalentsPage": {
    "title": "Organization talents"
  },
  "ResourceTypesSettingsMenu": {
    "triggerLabel": "Configure resource types",
    "heading": "Configure resource types",
    "allTypes": "All types",
    "global": "In this organization",
    "workspace": "In this workspace",
    "thisTypeInWorkspace": "{{name}} in this workspace"
  },
  "ResourceRowGallery": {
    "failedToLoad": "Failed to load pins",
    "empty": "No pins yet",
    "addContactPins": "Add pins"
  },
  "AssignResourcesToWorkspacesDialog": {
    "title": "Assign to workspaces",
    "description_one": "Choose how {{name}} is visible across workspaces.",
    "description_other": "Choose how these {{count}} resources are visible across workspaces.",
    "fieldScope": "Visibility",
    "scopeHidden": "Hidden",
    "scopeHiddenHint": "No workspace membership — not listed anywhere (admin-only).",
    "scopeGlobal": "Global",
    "scopeGlobalHint": "Visible in every workspace (membership with no workspace id).",
    "scopeWorkspaces": "Specific workspaces",
    "fieldWorkspaces": "Workspaces",
    "workspacesSelectPrompt": "Select one or more workspaces",
    "workspacesSelectedCount": "{{count}} selected",
    "workspacesUnselectAll": "Unselect all",
    "workspacesEmpty": "No workspaces available",
    "save": "Assign",
    "assignFailed": "Failed to assign workspaces",
    "unsavedChangesBeforeUnload": "You have unsaved changes!",
    "success_one": "Resource assigned to workspaces",
    "success_other": "{{count}} resources assigned to workspaces"
  },
  "ResourceWorkspacesCell": {
    "hidden": "Hidden",
    "global": "Global"
  },
  "ResourceCreateForm": {
    "profilePicture": "Profile picture",
    "resourceType": "Resource type"
  },
  "ResourceCreateDialog": {
    "title": "Create resource",
    "titleTypeAndVisibility": "Create resource · type & visibility",
    "titleType": "Create resource · type",
    "titleDetails": "Create resource · details",
    "description": "Create a new resource",
    "actions": {
      "add-another": "Save & add another",
      "go-to-profile": "Save & go to profile",
      "close": "Save"
    },
    "createFailed": "Failed to create resource",
    "noResourceTypes": "No resource types are available."
  },
  "CreateDraftSummary": {
    "change": "Change"
  },
  "ResourceDuplicatesFooter": {
    "title": "Looks familiar?",
    "titleExact": "Someone with this name already exists",
    "summary_one": "{{count}} existing resource has a similar name",
    "summary_other": "{{count}} existing resources have a similar name",
    "summaryNamed_one": "{{count}} existing resource looks like “{{name}}”",
    "summaryNamed_other": "{{count}} existing resources look like “{{name}}”",
    "review": "Review",
    "hide": "Hide",
    "dismiss": "Dismiss",
    "exactMatch": "Same name",
    "similarMatch": "Similar",
    "openProfile": "Open",
    "openProfileOf": "Open the profile of {{name}} in a new tab",
    "hint": "Profiles open in a new tab, so your draft stays here. Different person? Just save."
  },
  "ResourceSchema": {
    "coreLabel": {
      "fullName": "Full name",
      "pronouns": "Pronouns",
      "emails": "Email Addresses",
      "phoneNumbers": "Phone Numbers",
      "socials": "Social Media",
      "websites": "Websites",
      "tags": "Tags",
      "groups": "Groups",
      "locations": "Locations",
      "rates": "Rates",
      "agent": "Agent",
      "organization": "Organization",
      "nickname": "Nickname",
      "role": "Role"
    },
    "enterPlaceholder": "Enter {{label}}",
    "globalSection": "Global",
    "locationItemTitle": "Location",
    "rateItemTitle": "Rate",
    "addRate": "Add rate",
    "blankRate": "Blank rate",
    "blankRateHint": "Type the amount",
    "fromRateCard": "From rate card",
    "addItem": "Add {{name}}"
  },
  "ResourceEditorVersionSwitch": {
    "title": "Resource editor",
    "newVersionDescription": "You're trying the new editor. It's still experimental — if something looks off, switch back. Your data stays the same.",
    "oldVersionDescription": "You're on the classic editor. The new one is in beta — give it a go anytime."
  },
  "ResourceNotesPanel": {
    "title": "Notes",
    "fieldLabel": "New note",
    "placeholder": "Write a note…",
    "submit": "Add note",
    "emptyTitle": "No notes yet",
    "emptyDescription": "Write notes about {{name}}.",
    "fallbackName": "this resource",
    "loadError": "Could not load notes.",
    "unknownUser": "Unknown user",
    "deleteAria": "Remove note",
    "createdToast": "Note added",
    "createErrorToast": "Could not add note",
    "deletedToast": "Note removed",
    "deleteErrorToast": "Could not remove note"
  },
  "ResourceFilesPanel": {
    "title": "Documents",
    "emptyTitle": "No documents yet",
    "emptyDescription": "Keep track of important documents and files for {{name}}.",
    "fallbackName": "this resource",
    "loadError": "Could not load documents.",
    "untitled": "Untitled file",
    "uploadedToast": "File uploaded",
    "uploadErrorToast": "Upload failed",
    "deletedToast": "File removed",
    "deleteErrorToast": "Could not remove file",
    "reorderErrorToast": "Could not save the new order"
  },
  "ResourcePane": {
    "invalidDataDescription": "We're showing this form anyway, but it may not work correctly. If you run into problems, contact support."
  }
}
